import { atom } from "recoil";
import { IRulesApiFilter } from "../../api/types";
import { RuleStatus } from "../../types";

export const rulesFilterState = atom<IRulesApiFilter>({
    key: 'rulesFilterState',
    default: {
        status: RuleStatus.Active
    }
});